import { createColumn, createCheckboxColumn } from "../components/Table/Table";

export const ioConfigurationColumns: State.Column[] = [
  createColumn(
    "Name",
    (ioConfiguration: Api.IoConfiguration) => ioConfiguration.friendlyName,
    "ioConfiguration.friendlyName",
    true
  ),
  createColumn(
    "Sw version",
    (ioConfiguration: Api.IoConfiguration) => ioConfiguration.kceVersion.name,
    "ioConfiguration.kceVersion.name",
    true
  ),
  createColumn(
    "Product",
    (ioConfiguration: Api.IoConfiguration) => ioConfiguration.kceProduct.productName,
    "ioConfiguration.kceProduct.productName",
    true
  ),
  createColumn(
    "Last Modified",
    (ioConfiguration: Api.IoConfiguration) => ioConfiguration.modified,
    "ioConfiguration.modified",
    true
  ),
  createColumn(
    "Modifier",
    (ioConfiguration: Api.IoConfiguration) => ioConfiguration.modifiedBy,
    "ioConfiguration.modifiedBy",
    true
  ),
  createColumn(
    "Comment",
    (ioConfiguration: Api.IoConfiguration) => ioConfiguration.comment,
    "ioConfiguration.comment",
    true
  ),
  createCheckboxColumn(
    "Locked",
    (ioConfiguration: Api.IoConfiguration) => ioConfiguration.locked,
    "ioConfiguration.locked",
    true
  )
];
export const standardBoardColumns: State.Column[] = [
  createColumn(
    "Id",
    (standardBoard: Api.StandardBoard) => standardBoard.boardType.boardTypeId,
    "standardBoard.boardType.boardTypeId",
    true
  ),
  createColumn(
    "Board Type",
    (standardBoard: Api.StandardBoard) => standardBoard.boardType.enumName,
    "standardBoard.boardType.enumName",
    true
  ),
  createColumn(
    "Revision",
    (standardBoard: Api.StandardBoard) => standardBoard.revision,
    "standardBoard.revision",
    true
  )
];
